export default function SetActiveAlert(state, payload) {
  return {...state, activeAlert: payload}
}